module.exports = __webpack_public_path__ + "assets/corekees-en.aa7b2324.svg";